<template>
    <b-modal id="customer-choose-pack" class="customer-show-quotation" ref="modal" :title="dialog_title" hide-footer>
        <div class="row form-group">
            <div class="col">
                <v-select style="flex-grow: 1;" ref="psearch" class="wabident-selector" @search="searchPacks"
                    :filterable="false" :options="packs" placeholder="Escribe el nombre del pack que quieres añadir"
                    v-model="selected_pack"></v-select>
            </div>
        </div>
        <div v-if="selected_pack && !this.loading_pack_products" class="row">
            <div class="col">
                <table class="table">
                    <thead>
                        <tr>
                            <th>ORD</th>
                            <th>TRATAMIENTO</th>
                            <th>P. UNIT</th>
                            <th>CANT</th>
                            <th>DESC %</th>
                            <th>DESC €</th>
                            <th>SUBTOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(line, key) in pack_lines" :key="key">
                            <td>{{ key + 1 }}</td>
                            <td>{{ line.name }}</td>
                            <td>{{ line.price }}</td>
                            <td>{{ line.quantity }}</td>
                            <td>{{ line.discount }}%</td>
                            <td>{{ line.abs_discount }}</td>
                            <td>{{ line.total_price }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="selected_pack && !this.loading_pack_products" class="row">
            <div class="col">
                <button style="height: 50.50px;" class="btn btn-wabident-round float-right" @click="addPack">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <g clip-path="url(#clip0_207_1621)">
                            <path
                                d="M10.4508 5.05076L6.94923 5.05076L6.94923 1.54919C6.94923 1.29745 6.84922 1.05601 6.67121 0.877996C6.49319 0.699983 6.25176 0.599976 6.00001 0.599976C5.74826 0.599976 5.50682 0.699983 5.32881 0.877996C5.15079 1.05601 5.05079 1.29745 5.05079 1.54919L5.05079 5.05076L1.54922 5.05076C1.29748 5.05076 1.05604 5.15076 0.878025 5.32878C0.700012 5.50679 0.600006 5.74823 0.600006 5.99998C0.600006 6.25172 0.700012 6.49316 0.878025 6.67117C1.05604 6.84919 1.29748 6.94919 1.54922 6.94919L5.05079 6.94919L5.05079 10.4508C5.05079 10.7025 5.15079 10.9439 5.32881 11.122C5.50682 11.3 5.74826 11.4 6.00001 11.4C6.25175 11.4 6.49319 11.3 6.6712 11.122C6.84922 10.9439 6.94922 10.7025 6.94922 10.4508L6.94922 6.94919L10.4508 6.94919C10.7025 6.94919 10.944 6.84919 11.122 6.67117C11.3 6.49316 11.4 6.25172 11.4 5.99998C11.4 5.74823 11.3 5.50679 11.122 5.32878C10.944 5.15076 10.7025 5.05076 10.4508 5.05076Z"
                                fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_207_1621">
                                <rect width="12" height="12" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    Añadir pack
                </button>
            </div>
        </div>
    </b-modal>
</div></template>

<script>
export default {
    data() {
        return {
            selected_pack: null,
            searched_packs: [],
            selected_pack_products: {},
            loading_pack_products: false,
        }
    },
    computed: {
        pack_lines() {
            return this.selected_pack.value.pack_lines.map((line) => {
                const product = line.product;
                return {
                    name: product.name,
                    price: line.price ? window.WabiDent.fmtMoney(line.price) : window.WabiDent.fmtMoney(product.price),
                    quantity: line.quantity,
                    discount: line.discount,
                    abs_discount: window.WabiDent.fmtMoney(line.abs_discount),
                    total_price: window.WabiDent.fmtMoney(this.getTotalPrice(line)),
                }
            });
        },
        packs() {
            return this.searched_packs.map((pack) => {
                return {
                    label: pack.name,
                    value: pack
                };
            });
        },
        dialog_title() {
            return 'Añadir Pack de Tratamientos'
        },
        ...mapGetters(['clinic'])
    },
    watch: {
        selected_pack(val) {
            this.updatePackProducts(val);
        },
    },
    methods: {
        addPack() {
            this.$emit('add', this.selected_pack.value);
            this.$refs.modal.hide();
        },
        show() {
            this.search = null;
            this.selected_pack = null;
            this.searched_packs = [];
            this.$refs.modal.show();
        },
        searchPacks(search, loading = null) {
            if (loading) {
                loading(true);
            }

            const nopaginate = true;
            const params = { search, nopaginate };

            axios
                .get("/pack", { params })
                .then((response) => {
                    this.searched_packs = response.data;
                })
                .catch((err) => {
                    console.log("[ERR] searchPacks", err);
                    this.msgwindow.error("Error buscando Packs");
                })
                .then(() => {
                    loading(false);
                });
        },
        getTotalPrice(line) {
            const product = line.product;
            let price = 0;

            if (product) {
                price =
                    Number(line.price ? line.price : product.price) *
                    Number(line.quantity) *
                    (1 - Number(line.discount) / 100);
                price -= Number(line.abs_discount);
            }
            return price;
        },
        updatePackProducts(selected_product) {
            if (!selected_product) {
                this.selected_pack_products = {};
                return;
            }

            if (this.loading_pack_products) {
                return;
            }

            this.loading_pack_products = true;
            let product_ids = selected_product.value.pack_lines.map((l) => {
                return l.product_id;
            });

            axios
                .get("/product", {
                    params: { product_ids: product_ids, },
                }).then((response) => {
                    let product_dict = {};
                    response.data.forEach((p) => {
                        product_dict[p.id] = p;
                    });

                    this.selected_pack_products = product_dict;
                    this.selected_pack.value.pack_lines.forEach((line) => {
                        line.product = product_dict[line.product_id];
                    });
                }).catch((error) => {
                    console.log("[ERR] searchProducts:", error);
                }).then(() => {
                    this.loading_pack_products = false;
                });
        }
    }
}
</script>

<style lang="scss">
#customer-choose-pack {

    .modal-dialog {
        border-radius: 0;
        max-width: 1024px;
    }

    .modal-header {
        background-color: var(--theme-grey-bg);
    }

    .modal-header,
    .modal-content {
        border-radius: 0;
    }

    .modal-title {
        margin: 0;
        text-align: left;
        font-size: 18px;
    }

    .close {
        top: 15px;
    }

    .modal-body {
        padding: 20px;
    }
}
</style>